module.exports = __webpack_public_path__ + "a0cee31b42ab4c2a283ed85fa23e1571.pdf";